export const IMAGE_RATIO_DEFAULT = '4x3';
